import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ContactsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19 1a3 3 0 013 3v16a3 3 0 01-3 3H6a3 3 0 01-3-3v-1a1 1 0 010-2v-2a1 1 0 01-.117-1.993L3 13v-2a1 1 0 01-.117-1.993L3 9V7a1 1 0 01-.117-1.993L3 5V4a3 3 0 013-3h13zm0 2H6a1 1 0 00-1 1v1a1 1 0 01.117 1.993L5 7v2a1 1 0 01.117 1.993L5 11v2a1 1 0 01.117 1.993L5 15v2a1 1 0 010 2v1a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zm-5 10a4 4 0 014 4 1 1 0 01-2 0 2 2 0 00-1.85-1.995L14 15h-2a2 2 0 00-2 2 1 1 0 01-2 0 4 4 0 013.8-3.995L12 13h2zm-1-7a3 3 0 110 6 3 3 0 010-6zm0 2a1 1 0 100 2 1 1 0 000-2z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ContactsIcon.isCarinaIcon = true;
export default ContactsIcon;
